/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/

/*DATA*/

/*CONST*/
/*
  "JENIS",
  "MIN_LUAS",
  "MAX_LUAS",
  "MIN_RASIO",
  "MAX_RASIO",
  "MIN_LEBAR_JALAN",
  "TIPE_BANGUNAN",
  "BIAYA_PEMBANGUNAN_PER_M_2",
  "HARGA_SEWA_PER_M_2_PER_TAHUN",
  "OKUPANSI_PER_TAHUN",
  "DISEWAKAN_DIGUNAKAN",
  "FASUM",
  "PENDAPATAN PER M_2",
  "RASIO_BIOP_MIN",
  "RASIO_BIOP_MAX",
  "BIOP_PER_M2",
  */

class UJI_SUPPLY_DEMAND extends Component {
  state = {};

  render() {
    //local storage

    //local state

    //global props
    const {
      luas_tanah,
      LLBE,
      LLB,
      LLB_excel,
      hbu_type,
      panjang_tanah,
      lebar_tanah,
      ratio_tanah,
      rows_filtered_1,
      rows_rejected_1,
    } = this.props.hbu_reducer;

    const is_terbangun = hbu_type === "HBU Terbangun";
    const label_luas_bangunan = is_terbangun
      ? "Luas Lantai Bangunan Eksisting (LLBE)"
      : "Luas Lantai Bangunan (LLB)";
    const luas_bangunan = is_terbangun ? LLBE : LLB_excel || LLB;

    //content

    return (
      <main>
        <h1>Uji Supply dan Demand</h1>
        <hr />
        <div className="two_container_auto">
          <section>
            <h3 className="text_bold margin_bottom">Data objek</h3>
            <table className="table margin_bottom">
              <tbody>
                <tr>
                  <td>Luas tanah</td>
                  <td>{luas_tanah}</td>
                </tr>
                <tr>
                  <td>{label_luas_bangunan}</td>
                  <td>{luas_bangunan}</td>
                </tr>
                <tr>
                  <td>Panjang tanah</td>
                  <td>{panjang_tanah}</td>
                </tr>
                <tr>
                  <td>Lebar tanah</td>
                  <td>{lebar_tanah}</td>
                </tr>
                <tr>
                  <td>Rasion panjang/lebar</td>
                  <td>{ratio_tanah}</td>
                </tr>
              </tbody>
            </table>
          </section>
          <section>
            <h3 className="text_bold margin_bottom">Hasil uji</h3>
            <table className="table">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Nama alternatif</th>
                  <th>POI Support</th>
                  <th>Jumlah Minimal POI Support</th>
                  <th>Total POI Support di Lokasi</th>
                  <th>POI Resisten</th>
                  <th>Jumlah Maksimal POI Resisten</th>
                  <th>Total POI Resisten di Lokasi</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={9}>Lokasi Sesuai</td>
                </tr>
                {rows_filtered_1.map((item, idx) => {
                  let support_color =
                    item?.total_poi_support >= item?.JML_MIN_POI
                      ? "green"
                      : "red";
                  let resisten_color =
                    item?.total_poi_resisten <= item?.MAKS_RESISTEN
                      ? "green"
                      : "red";
                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{item?.JENIS}</td>
                      <td>{item?.POI_PENDUKUNG}</td>
                      <td>{item?.JML_MIN_POI}</td>
                      <td style={{ color: support_color }}>
                        {item?.total_poi_support}
                      </td>
                      <td>{item?.POI_RESISTEN_1KM}</td>
                      <td>{item?.MAKS_RESISTEN}</td>
                      <td style={{ color: resisten_color }}>
                        {item?.total_poi_resisten}
                      </td>
                      <td>
                        <div className="badge background_green">
                          Lokasi Sesuai
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tbody>
                <tr>
                  <td colSpan={9}>Tidak lolos uji</td>
                </tr>
                {rows_rejected_1.map((item, idx) => {
                  let support_color =
                    item?.total_poi_support >= item?.JML_MIN_POI
                      ? "green"
                      : "red";
                  let resisten_color =
                    item?.total_poi_resisten <= item?.MAKS_RESISTEN
                      ? "green"
                      : "red";
                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{item?.JENIS}</td>
                      <td>{item?.POI_PENDUKUNG}</td>
                      <td>{item?.JML_MIN_POI}</td>
                      <td style={{ color: support_color }}>
                        {item?.total_poi_support}
                      </td>
                      <td>{item?.POI_RESISTEN_1KM}</td>
                      <td>{item?.MAKS_RESISTEN}</td>
                      <td style={{ color: resisten_color }}>
                        {item?.total_poi_resisten}
                      </td>
                      <td>
                        <div className="badge background_red">
                          Lokasi Kurang Sesuai
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </section>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  loading_reducer: state.loading_reducer,
  sini: state.sini,
  properties: state.properties,
  layer: state.layer,
  hbu_reducer: state.hbu_reducer,
});

export default connect(mapStateToProps, {})(UJI_SUPPLY_DEMAND);
